import { getPath, type AnimationOptions, type Knob } from '@game-platform/pack-animation';

function isOn(knobs: readonly Knob[], options: AnimationOptions | undefined, path: string): boolean {
  const set = getPath(options, path);
  if (typeof set === 'boolean') return set;
  const knob = knobs.find((other) => other.path === path);
  return knob?.kind === 'toggle' ? knob.defaultValue : false;
}

function quoted(knobs: readonly Knob[], paths: readonly string[]): string {
  return paths
    .map((path) => `“${knobs.find((knob) => knob.path === path)?.label ?? path}”`)
    .join(' and ');
}

/**
 * Why the operator cannot change `knob` right now, as its tooltip; null when
 * they can. A knob waits for the toggles it `requires` to be on, and a toggle
 * that is on holds those on. Only a toggle that is on is held, so a saved
 * theme that has the requirement off can always be put right.
 */
export function knobLock(
  knob: Knob,
  knobs: readonly Knob[],
  options: AnimationOptions | undefined,
): string | null {
  const missing = (knob.requires ?? []).filter((path) => !isOn(knobs, options, path));
  if (missing.length > 0) return `Turn on ${quoted(knobs, missing)} first`;

  if (knob.kind !== 'toggle' || !isOn(knobs, options, knob.path)) return null;
  const holders = knobs
    .filter(
      (other) =>
        other.kind === 'toggle' &&
        other.requires?.includes(knob.path) === true &&
        isOn(knobs, options, other.path),
    )
    .map((other) => other.path);
  return holders.length > 0 ? `Stays on while ${quoted(knobs, holders)} is on` : null;
}
